module.exports = __webpack_public_path__ + "media/images/crm/main-illustration-cb92fdfc4f19b6e66156a3413b56b89a.png";